export default __webpack_public_path__ + "static/media/instagram-white.64cb320d.svg";